import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'models/meta/action';
import { navigate } from 'store/actions/common';
import { ResetPasswordSuccess } from './ResetPasswordSuccess.layout';
import { ResetPasswordSuccessProps, ResetPasswordSuccessDispatchProps } from './ResetPasswordSuccess.types';

const mapDispatchToProps = (dispatch: Dispatch): ResetPasswordSuccessDispatchProps =>
    ({ dispatchNavigate: (location, options) => { dispatch(navigate(location, options)); } });

export default compose<React.FC<Partial<ResetPasswordSuccessProps>>>(
    withTranslation('common'),
    connect(null, mapDispatchToProps)
)(ResetPasswordSuccess);
